import React, { ChangeEvent, useState } from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    closeModalFn: () => void;
    resendFn: (customMessage: string) => void;
    initialMessage: string;
};

export const ResendCustomMessageModal: React.FC<Props> = (props) => {
    const [customMessage, setCustomMessage] = useState(props.initialMessage);

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setCustomMessage(e.target.value);
    };

    const save = () => {
        props.resendFn(customMessage);
    };

    return (
        <div className={"ResendCustomMessageModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-envelope"} title={"edit_and_resend"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                    </div>
                </div>
            </div>

            <div className={"w-100"}>
                <div className={"mt-3 mb-3 text-muted"}>
                    <OwLabel title={"help_text_resend_custom_message"} />
                </div>
                <div>
                    <div>
                        <OwLabel title={"outbound_message"} />
                    </div>
                    <div>
                        <OwTextArea name={"custom_message"} fn={handleChange} value={customMessage} />
                    </div>
                </div>
            </div>

            <div className={"mt-3 w-100"}>
                <OwButton leftIconClass={"fas fa-paper-plane"} title={"resend"} fn={save} />
            </div>
        </div>
    );
};
